import {
  LINK_CARD_BEGIN,
  LINK_CARD_SUCCESS,
  LINK_CARD_FAILURE,
} from 'actions/link';

const initialState = {
  success: false,
  error: false,
  loading: false,
};

export default function link(state = initialState, action) {
  switch (action.type) {
    case LINK_CARD_BEGIN:
      return { ...initialState, loading: true };
    case LINK_CARD_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
      };
    case LINK_CARD_FAILURE:
      return { ...state, error: action.error, loading: false };
    default:
      return state;
  }
}
